import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"

// Connects to data-controller="left-menu"
export default class extends Controller {
  toggle(event) {
    const collapsed = this.element.dataset.collapsed !== "true"
    this.element.dataset.collapsed = collapsed

    this.closeAllSubmenus()
    // The expanded menu shows the group of the current page, like on page load
    if (!collapsed) {
      this.element
        .querySelectorAll(".nav-item.active-item")
        .forEach((item) => this.openSubmenu(item))
    }

    if (event.type === "click") {
      void patch(`/left_navigation_menu/${collapsed}`)
    }
  }

  toggleItem(event) {
    event.preventDefault()
    event.stopPropagation()

    const item = event.currentTarget.closest(".nav-item")

    if (item.classList.contains("submenu-open")) {
      this.closeSubmenu(item)
    } else {
      this.openSubmenu(item)
    }
  }

  openSubmenu(item) {
    this.element
      .querySelectorAll(".nav-item.submenu-open")
      .forEach((otherItem) => {
        if (otherItem !== item) this.closeSubmenu(otherItem)
      })

    item.classList.add("submenu-open")
    this.setExpanded(item, true)
  }

  closeSubmenu(item) {
    item.classList.remove("submenu-open")
    this.setExpanded(item, false)
  }

  // Hovering only opens flyouts while collapsed; expanded menus open on click.
  openSubmenuOnHover(event) {
    if (this.element.dataset.collapsed !== "true") return

    this.openSubmenu(event.currentTarget)
  }

  maybeCloseSubmenu(event) {
    if (this.element.dataset.collapsed !== "true") return

    const item = event.currentTarget
    if (event.relatedTarget && item.contains(event.relatedTarget)) return

    this.closeSubmenu(item)
  }

  closeAllSubmenus() {
    this.element
      .querySelectorAll(".nav-item.submenu-open")
      .forEach((item) => this.closeSubmenu(item))
  }

  setExpanded(item, expanded) {
    const button = item.querySelector("button[data-action*='toggleItem']")
    if (button) button.setAttribute("aria-expanded", expanded)
  }

  get menuElement() {
    return document.getElementById("left-navigation-menu") || this.element
  }

  openNav() {
    this.menuElement.classList.remove("-translate-x-full")
    this.menuElement.classList.add("translate-x-0")
  }

  closeNav() {
    this.menuElement.classList.remove("translate-x-0")
    this.menuElement.classList.add("-translate-x-full")
  }

  handleBeforeCache() {
    this.closeNav()
    this.closeAllSubmenus()
  }
}
